import { BookOpenText, PenIcon, X } from 'lucide-react';
import Icon from '@mdi/react';
import { useState } from 'react';
import { UseFormGetValues, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { translatePromptService } from 'src/services/AgentService';
import { AgentForm } from '../pages/ai-agent-v2/AgentSetupComponent';
import { SkillForm } from '../pages/ai-agent-v2/agentSetupComponent/agentSkillsComponent/AgentSkillsComponent';
import { Button } from '../ui/button';
import { TabsComponent } from './TabsComponent';
import { mdiLoading } from '@mdi/js';
import { useTranslate } from 'sbx-crm-menu-ui';

const classNameDefault = 'flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 mt-1 bg-white text-gray-900 !border-purple-300 !focus:border-purple-500 !focus:ring !focus:ring-purple-200 !focus:ring-opacity-50';

interface Props {
    originalPlaceholder: string,
    translatePlaceholder: string,
    keyFormOriginal: string,
    keyFormTranslate: string,
    label: string,
    getValues: UseFormGetValues<AgentForm> | UseFormGetValues<SkillForm>,
    setValue: UseFormSetValue<AgentForm> | UseFormSetValue<SkillForm>,
    watch: UseFormWatch<AgentForm> | UseFormWatch<SkillForm>,
    classNameTextArea?: string,
    disabled?: boolean,
}

export const TextAreaTranslateComponent = ({
                                               originalPlaceholder,
                                               translatePlaceholder,
                                               keyFormOriginal,
                                               keyFormTranslate,
                                               label,
                                               getValues,
                                               setValue,
                                               watch,
                                               classNameTextArea = classNameDefault,
                                               disabled
                                           }: Props) => {
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('original');
    const [disabledField, setDisabledField] = useState(true);
    const { t } = useTranslate('common');
    const getValuesV1 = getValues as any;
    const setValueV1 = setValue as any;
    const watchV1 = watch as any;

    const translateText = async () => {
        const value = getValuesV1(keyFormOriginal);
        setLoading(true);
        const res = await translatePromptService(value);
        if (res.success) {
            setValueV1(keyFormTranslate, res.item);
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="flex justify-between items-center">
                <label className="block text-sm leading-6 !text-purple-700 !font-semibold">{label}</label>
                <div className="flex items-center gap-2">
                    {
                        loading && (
                            <div className="flex justify-center items-center">
                                <Icon size={.7} path={mdiLoading} className="text-primary" spin />
                            </div>
                        )
                    }
                    <Button
                        onClick={() => setDisabledField(!disabledField)}
                        disabled={activeTab === 'original' || loading || disabled}
                        className="p-1 rounded-3xl h-fit"
                    >
                        {
                            disabledField ? <PenIcon className="h-4 w-4" />
                                : <X className="h-4 w-4" />
                        }
                    </Button>

                    <Button
                        onClick={translateText}
                        disabled={activeTab === 'original' || loading || watchV1(keyFormOriginal)?.length === 0 || disabled}
                        className="p-1 rounded-3xl h-fit"
                    >
                        <BookOpenText className="h-4 w-4" />
                    </Button>
                </div>
            </div>

            <TabsComponent
                tabsOptionsStyle="!px-2 !py-1 !text-xs"
                getActiveTab={(val) => setActiveTab(val)}
                tabs={[
                    {
                        label: 'original',
                        component: <textarea className={classNameTextArea} id="Prompt" placeholder={originalPlaceholder}
                                             onChange={(e) => setValueV1(keyFormOriginal, e.target.value)}
                                             value={watchV1(keyFormOriginal)} disabled={disabled} />,
                        disabled: false,
                    },
                    {
                        label: t('translated'),
                        component: <textarea disabled={disabledField || disabled} className={classNameTextArea} id="Prompt"
                                             placeholder={translatePlaceholder}
                                             onChange={(e) => setValueV1(keyFormTranslate, e.target.value)}
                                             value={watchV1(keyFormTranslate)} />,
                        disabled: watch(keyFormTranslate as any) === undefined,
                    },
                ]}
            />
        </div>
    );
};
